const excludeAttributes = (attributes, attributesToExclude) => {
  const excludeSet = new Set(attributesToExclude);

  return Object.fromEntries(Object.entries(attributes).filter(([name]) => !excludeSet.has(name)));
};

export default excludeAttributes;
